import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  getIncident,
  getIncidentCustomers,
  getIncidents,
  type GetIncidentCustomersParams,
  type GetIncidentsParams,
} from './api';

export function useIncidentsQuery(params: GetIncidentsParams) {
  return useQuery({
    queryKey: ['incidents', params],
    queryFn: () => getIncidents(params),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  });
}

export function useIncidentQuery(incidentId: string | undefined) {
  return useQuery({
    queryKey: ['incident', incidentId],
    queryFn: () => getIncident(incidentId as string),
    enabled: Boolean(incidentId),
    staleTime: 30 * 1000,
  });
}

export function useIncidentCustomersQuery(
  incidentId: string | undefined,
  params: GetIncidentCustomersParams,
) {
  return useQuery({
    queryKey: ['incident-customers', incidentId, params],
    queryFn: () => getIncidentCustomers(incidentId as string, params),
    enabled: Boolean(incidentId),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  });
}
